class JobDetailsController {
  constructor($stateParams, JobsService, $scope) {
    "ngInject"

    this.jobsService = JobsService;
    this.jobId = $stateParams.jobId;
    this.$scope = $scope;
    this.getJobPaymentDetails(this.jobId);
  }

  getJobPaymentDetails(jobId) {
    this.isLoading = true;

    this.jobsService.getJobPaymentDetails(jobId, (response) => {
      this.invoices = response.data;
      this.isLoading = false;
      this.$scope.$apply();
    },
    (error) => {
      this.isLoading = false;
      this.error = "Payment details not found";
      this.$scope.$apply();
    })
  }

  payHelper(invoiceId) {
    console.log('payHelper called with invoiceId:', invoiceId);
    const invoice = this.invoices.find(inv => inv.id === invoiceId);
    if (!invoice) {
      console.log('Invoice not found');
      return;
    }

    console.log('Processing payment for invoice:', invoice);
    invoice.isProcessing = true;
    this.$scope.$apply();

    this.jobsService.payHelper(invoiceId, (response) => {
      console.log('Payment success:', response);
      invoice.isProcessing = false;
      alert('Payment processed successfully');
      this.getJobPaymentDetails(this.jobId);
    },
    (error) => {
      console.log('Payment error:', error);
      invoice.isProcessing = false;
      alert((error.response && error.response.data && error.response.data.Message) || 'Payment failed');
      this.$scope.$apply();
    });
  }

  formatCurrency(amount) {
    return amount ? `$${(amount).toFixed(2)}` : '-';
  }

  formatDate(date) {
    return date ? new Date(date).toLocaleDateString('en-AU') : '-';
  }
}

export default JobDetailsController;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/job-details/job-details.controller.js
 **/